import Mock from "./mock";

import "./db/bookingtypes";
import "./db/guestsource";
import "./db/vdcontacts";
import "./db/property";

Mock.onAny().passThrough();
